export default __webpack_public_path__ + "static/media/honor-swiper-03.67798549.jpg";